import styled from "styled-components";
import { Form, Button } from "antd";
import { theme } from "../../../config";

export const FormItem = styled(Form.Item)`
  height: 85px;
  width: 100%;

  ${theme.formErrorMobileView}

  @media ${theme.breakpoints.mobileAndTablet} {
    height: 70px;
  }
`;

export const ChangePasswordButton = styled(Button)`
  padding: 10px 0;
`;

export const ErrorMessage = styled.span`
  color: ${theme.colors.utilities.error};
`;